import {
  SendOtpRequestAttributes,
  CheckOtpRequestAttributes,
  CheckPinRequestAttributes,
  AdminLoginRequestAttributes,
} from "../attributes/user-attributes";
import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import { base64toFile } from "../common/Hooks";
import BaseService from "./BaseService";

export class UserService extends BaseService {
  static sendOtp(
    data: SendOtpRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().post(`otp/send`, data);
  }

  static logout(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().delete(`auth/logout`);
  }

  static checkOtp(
    data: CheckOtpRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().put(`otp/verify`, data);
  }

  static checkPin(
    data: CheckPinRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().post(`auth/pin/check`, data);
  }

  static adminLogin(
    data: AdminLoginRequestAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().post(`auth/admin`, data);
  }

  static register(data: any): Promise<RestApiResponse<BaseResponseAttributes>> {
    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      if ("profile_picture" !== key.toString()) {
        formData.append(key, data[key]);
      }
    });

    // Add file data
    if (data.profile_picture !== null && data.profile_picture !== undefined) {
      formData.append(
        "profile_picture",
        base64toFile(data.profile_picture, "profile_picture.png")
      );
    }

    if (data.cni_back !== null && data.cni_back !== undefined) {
      formData.append("cni_back", base64toFile(data.cni_back, "cni_back.png"));
    }

    if (data.cni_front !== null && data.cni_front !== undefined) {
      formData.append(
        "cni_front",
        base64toFile(data.cni_front, "cni_front.png")
      );
    }

    if (data.passport !== null && data.passport !== undefined) {
      formData.append("passport", base64toFile(data.passport, "passport.png"));
    }

    return UserService.getApiClient().sendFormData({
      method: "post",
      url: "auth/register",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static authUser(
    accessToken?: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().get(`auth/user`, {
      params: { scopes: "businesses|managers" },
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    });
  }

  static getById(
    id: number,
    scopes = ""
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().get(`admin/users/${id}`, {
      params: { scopes: scopes },
    });
  }

  static declineUser(
    userId: number,
    comment: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().post(`admin/users/${userId}/decline`, {
      comment: comment
    });
  }

  static approveUser(
    userId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().put(`admin/users/${userId}/approve`);
  }

  static moreInfo(
    userId: number,
    comment: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().post(`admin/users/${userId}/moreinfo`, {
      comment: comment
    });
  }

  static activities(
      userId: number,
      page: number | null,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return UserService.getApiClient().get(`admin/users/${userId}/activities`, {
      "page": page
    });
  }
}

export default UserService;
